import { TableCell } from '@mui/material';
import Link from '@mui/material/Link';

import { ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface LinkCellProps {
  row: GenericObject;
  column: ColumnInterface;
}

export const LinkNewBrowserTabCell = ({ row, column }: LinkCellProps) => {
  return (
    <TableCell align="left">
      <Link rel="noopener noreferrer" target="_blank" href={column.getLink ? column.getLink(row) : ''} underline="none">
        {column.format ? column.format(row) : ''}
      </Link>
    </TableCell>
  );
};
